export interface TagSummaryDto {
  id: string
  label: string
  labelSpanish?: string | null
  description?: string | null
  tagType?: string | null
  isVisible: boolean
  canBeAssigned: boolean
  isOrganizationTag: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string
  createdByName: string
  contactCount: number
}

export interface TagDetailDto {
  id: string
  label: string
  labelSpanish?: string | null
  description?: string | null
  descriptionSpanish?: string | null
  scriptText?: string | null
  scriptTextSpanish?: string | null
  tagType?: string | null
  isVisible: boolean
  canBeAssigned: boolean
  isOrganizationTag: boolean
  isActive: boolean
  ownerCommitteeId: string
  createdAt: string
  updatedAt: string
  createdBy: string
  createdByName: string
}

export interface SaveTagRequest {
  label: string
  labelSpanish?: string | null
  description?: string | null
  descriptionSpanish?: string | null
  scriptText?: string | null
  scriptTextSpanish?: string | null
  tagType?: string | null
  isVisible?: boolean
  canBeAssigned?: boolean
  isOrganizationTag?: boolean
}

// Common tag types for dropdown
export const TAG_TYPES = [
  'Volunteer',
  'Donor',
  'Activist',
  'Issue',
  'Member',
  'Leader',
  'Supporter',
  'Opposition',
  'Undecided',
  'Custom',
] as const
